import { CmpInvoiceKindEnum } from "../../../../graphql/types";

export type ManageEventInvoiceIdentity = Readonly<{
  chamberId: string;
  eventId: string;
  invoiceId: string;
  sourceId: string;
}>;

export const getManageEventInvoiceIdentity = ({
  chamberId,
  eventId,
  eventRegistrationId,
  eventSponsorshipRequestId,
  invoiceId,
  invoiceKind,
}: {
  chamberId?: string | null;
  eventId?: string | null;
  eventRegistrationId?: string | null;
  eventSponsorshipRequestId?: string | null;
  invoiceId?: string | null;
  invoiceKind: CmpInvoiceKindEnum;
}): ManageEventInvoiceIdentity | null => {
  const normalizedChamberId = chamberId?.trim() || "";
  const normalizedEventId = eventId?.trim() || "";
  const normalizedInvoiceId = invoiceId?.trim() || "";
  const normalizedSourceId =
    (invoiceKind === CmpInvoiceKindEnum.EventRegistration
      ? eventRegistrationId
      : invoiceKind === CmpInvoiceKindEnum.EventSponsorship
        ? eventSponsorshipRequestId
        : null
    )?.trim() || "";

  if (
    !normalizedChamberId ||
    !normalizedEventId ||
    !normalizedInvoiceId ||
    !normalizedSourceId
  ) {
    return null;
  }

  return {
    chamberId: normalizedChamberId,
    eventId: normalizedEventId,
    invoiceId: normalizedInvoiceId,
    sourceId: normalizedSourceId,
  };
};
